module.exports = __webpack_public_path__ + "images/icons_v2/autoship-status-inactive-374ae10c.svg";